import { render } from "./AnagraficaDenominazione.vue?vue&type=template&id=56da2795&ts=true"
import script from "./AnagraficaDenominazione.vue?vue&type=script&lang=ts"
export * from "./AnagraficaDenominazione.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__